<template>
  <div v-if="errors || validator.getDebug()" class="form-error">
    <p v-for="(error, index) of errors" :key="index">
      {{ error }}
    </p>
    <template v-if="validator.getDebug()">
      <div v-if="validator.getDebug()" class="mt-2 border border-l-8 border-blue-200 p-2 text-xs">
        <p class="text-blue-400">{{ name }}</p>
        <p v-if="name" class="break-words text-xs text-neutral-750">
          {{ validator.getValue(name) || '--' }}
        </p>
        <template v-if="name && validator.silentErrors[name]">
          <p class="break-words text-xs text-red-500">invalid</p>
          <p v-for="(error, index) of validator.errors.value[name]" :key="`error${index}`" class="text-neutral-400">
            Noisy: {{ error }}
          </p>
          <p v-for="error of validator.silentErrors[name]" :key="error" class="text-neutral-400">Silent: {{ error }}</p>
        </template>
        <p v-else class="text-green-500">valid</p>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useValidator } from '@/validation/form-validator'

const validator = useValidator()
const props = defineProps<{ name: string }>()

const errors = computed((): boolean | string[] => {
  if (props.name) {
    return validator.getErrors(props.name)
  }
  return false
})
</script>
